"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagInnerSelected = void 0;
var _index = require("../../styles/index.js");
var _TagInner = require("./TagInner.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* TagInnerSelected is a variation of TagInner with some styling differences.
 * It is themable using Tag's selectedColorSet prop.
 */
var TagInnerSelected = exports.TagInnerSelected = (0, _styledComponents["default"])(_TagInner.TagInner).withConfig({
  displayName: "TagInnerSelected",
  componentId: "sc-19i8max-0"
})(["", ""], function (_ref) {
  var $fallbackSet = _ref.$fallbackSet;
  return (0, _styledComponents.css)(["background-color:", ";color:", ";"], (0, _index.cssColorValue)(_index.semanticColors.backgroundBase, $fallbackSet.background.base), (0, _index.cssColorValue)(_index.semanticColors.textBase, $fallbackSet.text.base));
});